import React, {useState, useEffect, useLayoutEffect} from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../Models/HeaderContainer';
import "../Styles/ProductDetails.css"
import Color from '../Components/Colors/Color';
import ClipLoader from "react-spinners/ClipLoader"
import "../Admin/Components/Overlay/Overlay.css"
import { useStateContext } from '../Contexts/productsCardContext';
import { fetchProductsDetail } from '../Admin/Controller/ProductController';

const ProductDetails = () => {

    const navigate = useNavigate();

    const {setPage} = useStateContext();
    const [loading, setLoading] = useState(false);
    const [product, setProduct] = useState({});
    const [error, setError] = useState(false);

    useEffect(() => {
        setPage('other');
    }, [])

    const urlLocation = useLocation();
    const queryParamsProducts = new URLSearchParams(urlLocation.search);
    const productId = queryParamsProducts.get('id');

    useEffect(() => {
        window.scrollTo(0,0);

        const handleFetchProductDetail = async () => {
            try{
                setLoading(true);
                const response = await fetchProductsDetail(productId);
                const status = response.status;

                if(status === 200){
                    const productFound = response.data.product;
                    setProduct(productFound || {});
                } else {
                    console.log("response" + response);               
                }
    
            }catch(error)  {
                if(error?.response?.status === 404){
                    setError(true);
                    setTimeout(() => {
                        navigate('/products');
                    },[3000])
                }
                console.log(error?.response?.data?.message || "No product found");
            }finally{
                setLoading(false);
            }
        }

        handleFetchProductDetail();
    },[])
    
    // useEffect(() => {
    //     setPage('other');
    //     const selectedProduct = productData.products.filter((product) =>
    //         product.id === productId
    //       );
        
    //     setProduct(selectedProduct[0]);
    // }, [])


    return(
        <div className='product-details-container' style={{backgroundColor: Color.primaryBackground, color: Color.secondaryText}}>
            {product ? <Header name="Product Details"/> : 
                <Header name= "Product Details"/>
            }
            <div className='product-details-content'>
                {!loading && product && !error ? 
                <>
                    <div className='product-details-header-container'>
                        <h2 className='product-details-header'>
                            {product.name}
                        </h2>
                    </div>
                    <div className='product-details-image-container'>
                        <img src={product.imageLink} alt='product-img' className='product-details-image' />
                    </div>

                    <div className='product-details-content-container'>
                        <p className='product-details-content' style={{color: Color.secondaryText}}>
                            {product.description}
                        </p>
                        {product.productLists ? (
                            <div className='product-details-packing'>
                                {product.productLists.length !== 0 && (
                                    <h4 className='product-details-content-header' style={{color: Color.secondaryText}}>
                                        Products
                                    </h4>
                                )}
                                <ul className='product-details-packing-list'>
                                {product.productLists.map((item, index) => (
                                        <li key={index} className='product-details-packing-list-item' style={{color: Color.secondaryText}}>
                                            {item.name}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                    ) : <></>}
                    </div> 
                </> : 

                <></>
}

                {!loading && error &&
                    <div className='product-details-content-container'>
                        <p className='product-details-content' style={{color: Color.secondaryText}}>
                            There is no product with this id.
                        </p>
                    </div>
                }

                <div className={`loading-container-overlay-small ${loading ? "" : "stop"}`}>
                    <ClipLoader color='white' size={100} />
                </div>
                
            </div>
            
        </div>
    )
}

export default ProductDetails;